// IBM Plex Sans (UI) + IBM Plex Mono (ids, prices, tool names, versions, code).
// Loaded via Google Fonts on web; bundled font files on native.
export const FontFamily = {
  sans: 'IBM Plex Sans',
  mono: 'IBM Plex Mono',
};

// Sizes seen across the HTML (px). Body is 13; mono ids ~10.5–13; KPI values 24–28.
export const FontSize = {
  xs:  11,
  sm:  12,
  md:  13,
  lg:  15,
  xl:  18,
  '2xl': 22,
  '3xl': 28,
};

export const FontWeight = {
  regular:  '400' as const,
  medium:   '500' as const,
  semibold: '600' as const,
  bold:     '700' as const,
};

export const LineHeight = {
  tight:   1.25,
  normal:  1.45, // body
  relaxed: 1.6,  // mono prompt textareas
};
